<template>
    <div class="tab-content" v-if="positionDetail">
        <div class="tab-box" v-if="positionDetail.temptation || (positionSurveyView && positionSurveyView.mustSurveyPropertys&&positionSurveyView.mustSurveyPropertys.length)">
            <div v-if="positionDetail.temptation" style="margin-bottom: 20px">
                <h2 class="tab-title">岗位卖点</h2>
                <p>{{positionDetail.temptation}}</p>
            </div>
            <div v-if="positionSurveyView && positionSurveyView.mustSurveyPropertys&&positionSurveyView.mustSurveyPropertys.length">
                <h2 class="tab-title red">必须信息</h2>
                <ul class="tab-list">
                    <li v-for="(item,index) in positionSurveyView.mustSurveyPropertys" :key="index">
                        <label>{{item.surveyName}}</label>
                        <div class="box" :class="item.surveyKey == 'workStability'?'red':''">{{item.surveyValue}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-box" v-if="positionSurveyView && positionSurveyView.mustSurveyPropertys&&positionSurveyView.priorSurveyPropertys.length">
            <h2 class="tab-title orange">优先信息</h2>
            <ul class="tab-list">
                <li v-for="(item,index) in positionSurveyView.priorSurveyPropertys" :key="index">
                    <label>{{item.surveyName}}</label>
                    <div class="box" :class="item.surveyKey == 'workStability'?'red':''">{{item.surveyValue}}</div>
                </li>
            </ul>
        </div>
        <div class="tab-box" v-if="positionSurveyView && positionSurveyView.mustSurveyPropertys&&positionSurveyView.positionSurveyBaseBean.otherRequired">
            <h2 class="tab-title gray">其他</h2>
            <ul class="tab-list">
                <li>
                    <div class="box" v-html="positionSurveyView.positionSurveyBaseBean.otherRequired"></div>
                </li>
            </ul>
        </div>
        <div class="tab-box" v-if="positionDetail.jobDescription || positionDetail.jobRequirement">
            <h2 class="tab-title">岗位信息</h2>
            <ul class="tab-list">
                <li>
                    <label>岗位职责</label>
                    <div class="box" v-if="positionDetail.jobDescription">{{positionDetail.jobDescription}}</div>
                </li>
                <li>
                    <label>任职要求</label>
                    <div class="box" v-if="positionDetail.jobRequirement">{{positionDetail.jobRequirement}}</div>
                </li>
            </ul>
        </div>
        <div class="tab-box" v-if="positionDetail || positionSurveyView">
            <h2 class="tab-title">职位说明</h2>
            <ul class="tab-list">
                <li>
                    <label>行业</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.positionIndustry ? positionSurveyView.positionSurveyBaseBean.positionIndustry : positionDetail.positionIndustry}}</div>
                </li>
                <li>
                    <label>职能</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.positionTitle ? positionSurveyView.positionSurveyBaseBean.positionTitle : positionDetail.positionTitleTag}}</div>
                </li>
                <li>
                    <label>招聘人数</label>
                    <div class="box">{{positionDetail.headCount ? positionDetail.headCount+'人' : ''}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.openReasonType">
                    <label>开放原因</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.openReasonType}}</div>
                </li>
                <li v-else>
                    <label>开放原因</label>
                    <div class="box">{{positionDetail.openReasonInfo}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.openReasonInfo">
                    <label>开放原因说明</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.openReasonInfo}}</div>
                </li>
                <li v-if="positionDetail.businessReqResultDesc">
                    <label>行业要求：</label>
                    <div class="box">{{positionDetail.businessReqResultDesc}}</div>
                </li>
                <li>
                    <label>职位年薪</label>
                    <div class="box">￥{{positionDetail.annualSalaryDesc}}万<span v-if="positionDetail.positionSurvey && positionDetail.positionSurvey.annualSalaryBeforeTaxDescription">({{positionDetail.positionSurvey.annualSalaryBeforeTaxDescription}})</span></div>
                </li>
                <li v-if="positionDetail.monthSalaryRuleView">
                    <label>月薪制度</label>
                    <div class="box">{{positionDetail.monthSalaryRuleView}}</div>
                </li>
                <li v-if="positionDetail.positionSurvey.salaryRuleConstitute || positionDetail.salarySupplement">
                    <label>薪资构成</label>
                    <div class="box">{{positionDetail.positionSurvey && positionDetail.positionSurvey.salaryRuleConstitute ? positionDetail.positionSurvey.salaryRuleConstitute : positionDetail.salarySupplement}}</div>
                </li>
                <li
                        v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.socialSecurityBenefits">
                    <label>社保福利</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.socialSecurityBenefits}}</div>
                </li>
                <li
                        v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.housingBenefits">
                    <label>住房福利</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.housingBenefits}}</div>
                </li>
                <li
                        v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.holidayBenefits">
                    <label>假期福利</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.holidayBenefits}}</div>
                </li>
                <li v-if="positionDetail.positionSurvey.place">
                    <label>通讯交通</label>
                    <div class="box">{{positionDetail.positionSurvey.place}}</div>
                </li>
                <li
                        v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.responsibleProductProjectArea">
                    <label>负责产品/项目/区域</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.responsibleProductProjectArea}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.department || positionDetail.department">
                    <label>所属部门</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.department ? positionSurveyView.positionSurveyBaseBean.department : positionDetail.department}}</div>
                </li>
                <li v-if="positionDetail.positionSurvey&&positionDetail.positionSurvey.architectInfo">
                    <label>部门介绍</label>
                    <div class="box">{{positionDetail.positionSurvey.architectInfo}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.leaderPositionTitle">
                    <label>上级岗位&背景</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.leaderPositionTitle}}<br>{{positionSurveyView.positionSurveyBaseBean.leaderPositionTitleDesc}}</div>
                </li>
                <li v-else>
                    <label>上级岗位&背景</label>
                    <div class="box">{{positionDetail.reportTo}}<br>{{positionDetail.reportToDesc}}</div>
                </li>
                <li v-if="positionDetail.positionSurvey && positionDetail.positionSurvey.punchCard">
                  <label>上班时间：</label>
                  <div class="box">{{positionDetail.positionSurvey.punchCard == 1 ? '打卡' : '不打卡'}}&nbsp;&nbsp;{{positionDetail.positionSurvey.workHours}}</div>
                </li>
                <!-- <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.workAddress">
                    <label>工作地点</label>
                    <div class="box">
                        <a :href="'http://api.map.baidu.com/geocoder?address='+ positionSurveyView.positionSurveyBaseBean.workAddress +'&output=html&src=webapp.baidu.openAPIdemo'">{{positionSurveyView.positionSurveyBaseBean.workAddress}}</a>
                    </div>
                </li> -->
                <li v-if="positionDetail.locations && positionDetail.locations.length">
                    <label>工作地点</label>
                    <div class="box">
                        <p v-for="(item, index) in positionDetail.locations" :key="index">
                            <a :href="'http://api.map.baidu.com/geocoder?address='+ (item.workProvinceName == item.workCityName?item.workProvinceName : item.workProvinceName + item.workCityName) + item.workAddress +'&output=html&src=webapp.baidu.openAPIdemo'">{{ (item.workProvinceName == item.workCityName?item.workProvinceName : item.workProvinceName + item.workCityName) + item.workAddress}}</a>
                        </p>
                    </div>
                    
                </li>
                <li>
                    <label>佣金计算</label>
                    <div class="box red">￥{{positionDetail.rewardViewDesc}}</div>
                </li>
                <li v-if="positionDetail.virtualPayRate">
                    <label>佣金分成</label>
                    <div class="box">{{positionDetail.virtualPayRate}}</div>
                </li>
                <li v-if="positionDetail.commissionSupplement">
                    <label>佣金说明</label>
                    <div class="box">{{positionDetail.commissionSupplement}}</div>
                </li>
            </ul>
        </div>
        <div class="tab-box">
            <h2 class="tab-title">面试评估</h2>
            <ul class="tab-list">
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.interviewRotationNum || positionDetail.interviewRotationNum">
                    <label>面试轮次</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.interviewRotationNum ? positionSurveyView.positionSurveyBaseBean.interviewRotationNum : positionDetail.interviewRotationNum}}次</div>
                </li>
                <li v-else>
                    <label>面试轮次</label>
                    <div class="box">{{positionDetail.interviewTimes | interviewTimesFilter}}次</div>
                </li>
                <li v-if="positionDetail.interviewProcessJson && positionDetail.interviewProcessJson.length">
                    <label>面试流程：</label>
                    <div class="box">
                        <p class="step-wrap" v-for="(interview,index) in positionDetail.interviewProcessJson">
                            <span v-if="interview.interviewRotationNum">{{interview.interviewRotationNum}}</span>
                            <span v-if="interview.interviewer">{{interview.interviewer}}</span>
                            <span v-if="interview.interviewValue">{{interview.interviewValue}}</span>
                        </p>
                    </div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.interviewAddress">
                    <label>面试地点</label>
                    <div class="box">
                        <a :href="'http://api.map.baidu.com/geocoder?address='+ positionSurveyView.positionSurveyBaseBean.interviewAddress +'&output=html&src=webapp.baidu.openAPIdemo'">{{positionSurveyView.positionSurveyBaseBean.interviewAddress}}</a>
                    </div>
                </li>
                <li v-else>
                    <label>面试地点</label>
                    <div class="box">
                        <a :href="'http://api.map.baidu.com/geocoder?address='+ positionDetail.interviewProvince + (positionDetail.interviewCity!=positionDetail.interviewProvince ? positionDetail.interviewCity : '') + positionDetail.interviewAddress +'&output=html&src=webapp.baidu.openAPIdemo'">{{positionDetail.interviewProvince}} {{positionDetail.interviewCity!=positionDetail.interviewProvince ? positionDetail.interviewCity : ''}} {{positionDetail.interviewAddress}}</a>
                    </div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && (positionSurveyView.positionSurveyBaseBean.ifOtherPlace || positionSurveyView.positionSurveyBaseBean.ifOtherPlace==0)">
                    <label>异地面试</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.ifOtherPlace ? '是' : '否'}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.ifOtherPlace && (positionSurveyView.positionSurveyBaseBean.ifOtherPlaceReimbursement || positionSurveyView.positionSurveyBaseBean.ifOtherPlaceReimbursement==0)">
                    <label>异地面试报销</label>
                    <div class="box">{{positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.ifOtherPlaceReimbursement ? '有报销' : '无报销'}}</div>
                </li>
                <li v-if="positionSurveyView && positionSurveyView.positionSurveyBaseBean && positionSurveyView.positionSurveyBaseBean.ifOtherPlace && positionSurveyView.positionSurveyBaseBean.ifOtherPlaceReimbursement && positionSurveyView.positionSurveyBaseBean.reimbursementProcess">
                    <label>报销流程</label>
                    <div class="box">{{positionSurveyView.positionSurveyBaseBean.reimbursementProcess}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
        positionDetail:{},
        positionSurveyView:{}
    },
    data() {
      return {

      }
    },
    created() {
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.tab-content{
    padding: 15px 0;
    .tab-box{
        &:not(:last-child){
            margin-bottom: 20px;
            border-bottom: 0.5px solid #e5e5e5;
        }
        .tab-title{
            font-family: PingFangSC-Semibold;
            margin-bottom: 15px;
        }
        .tab-list{
            li{
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                margin-bottom: 15px;
                label{
                    width: 70px;
                    min-width: 70px;
                    margin-right: 20px;
                    color: #666;
                }
                .box{
                    white-space: pre-line;
                    .step-wrap{
                        span{
                            &:after{
                                content: ' > ';
                            }
                            &:last-child:after{
                                display: none;
                            }
                        }
                    }
                }
                .city {
                    display:  block;
                }
            }
        }
    }
}
</style>
